
    import '/Users/lijixiang/Work/power-design/site/docs/flow-components/approval-reminder.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-flow-components-approval-reminder-demo-approval-reminder"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/flow-components/approval-reminder.md?type=demo')
};